import { where, documentId } from 'firebase/firestore';
import {
  updateDataById,
  fetchByTable,
  addDataToTable,
  deleteDocById,
} from '../utils';

export const updateUser = async (id, data, setLoading) =>
  updateDataById({ id, tableName: 'users', data, setLoading });

export const removeFriend = async (userId, friends, friendId, setLoading) =>
  updateDataById({
    id: userId,
    tableName: 'users',
    data: { friendsIds: friends.filter(f => f !== friendId) },
    setLoading,
  });

export const removePlayerFromfriendsList = async (
  userId,
  friendsListId,
  friendsList,
  friendsListPlayerId,
  setLoading,
) => {
  updateDataById({
    id: userId,
    tableName: 'users',
    data: {
      friendsList: friendsList.map(t =>
        t.friendsListName === friendsListId
          ? {
              ...t,
              players: t.players.filter(p => p.id !== friendsListPlayerId),
            }
          : t,
      ),
    },
    setLoading,
  });
};
export const addPlayerToFriendsList = async (
  userId,
  friendsListId,
  friendsList,
  player,
  setLoading,
) =>
  updateDataById({
    id: userId,
    tableName: 'users',
    data: {
      friendsList: friendsList.map(t =>
        t.friendsListName === friendsListId
          ? { ...t, players: [...t.players, player] }
          : t,
      ),
    },
    setLoading,
  });

export const addFriendsListToPlayer = async (
  userId,
  friendsListName,
  setLoading,
  friendsList = [],
) =>
  updateDataById({
    id: userId,
    tableName: 'users',
    data: {
      friendsList: [...friendsList, { friendsListName, players: [] }],
    },
    setLoading,
  });
export const removeFriendsListFromUser = async (
  userId,
  friendsListName,
  setLoading,
  friendsList = [],
) =>
  updateDataById({
    id: userId,
    tableName: 'users',
    data: {
      friendsList: friendsList.filter(
        t => t.friendsListName !== friendsListName,
      ),
    },
    setLoading,
  });

export const fetchUserByEmail = async (email, setLoading) =>
  fetchByTable({
    tableName: 'users',
    whereCondition: where('email', '==', email),
    setLoading,
  });

export const fetchUserById = async (id, setLoading) =>
  fetchByTable({
    tableName: 'users',
    whereCondition: where(documentId(), '==', id),
    setLoading,
  });

export const fetchUsersById = async (ids, setLoading) =>
  fetchByTable({
    tableName: 'users',
    whereCondition: where(documentId(), 'in', ids),
    setLoading,
  });

export const addRequest = async (request, setLoading) =>
  addDataToTable({ tableName: 'requests', data: request, setLoading });

export const rejectRequest = async (id, setLoading) =>
  deleteDocById({ tableName: 'requests', id, setLoading });
